import { ActionsUnion, createAction } from "store/helper";

import { ILoadWidgetPayload } from "./interfaces";

export enum FullscreenWidgetsViewActionNames {
  LOAD_WIDGET = "VIEWS/FULLSCREEN_WIDGETS/LOAD_WIDGET",
}

export const FullscreenWidgetsViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  load: (payload: ILoadWidgetPayload) => createAction(FullscreenWidgetsViewActionNames.LOAD_WIDGET, payload),
};

export type FullscreenWidgetsViewTypes = ActionsUnion<typeof FullscreenWidgetsViewActions>;
